import React from "react";
import { Timeline } from "antd";

import "./styles.scss";

const data2 = [
  {
    icon: "https://fsposeidon.blob.core.windows.net/roldan/icon_landTracking@16x.svg",
    name: "Instrucción de cliente AA",
    value: 37,
  },
  {
    icon: "https://fsposeidon.blob.core.windows.net/roldan/icon_documentDownload@16x.svg",
    name: "ATA (Manifesto)",
    value: 355,
  },
  {
    icon: "https://fsposeidon.blob.core.windows.net/roldan/icon_warehouse@16x.svg",
    name: "Ingreso depósito",
    value: 74,
  },
  {
    icon: "https://fsposeidon.blob.core.windows.net/roldan/icon_warehouse@16x.svg",
    name: "Desaduanamiento",
    value: 7,
  },
  {
    icon: "https://fsposeidon.blob.core.windows.net/roldan/icon_certificateCheck@16x.svg",
    name: "Levante",
    value: 4,
  },
  {
    icon: "https://fsposeidon.blob.core.windows.net/roldan/icon_landFreight@16x.svg",
    name: "Despacho",
    value: 140,
  },
  {
    icon: "https://fsposeidon.blob.core.windows.net/roldan/icon_certificateCheck@16x.svg",
    name: "Radicación de factura",
    value: 2839,
  },
];
const HorizontalTimeline = ({ data }) => {
  return (
    <div style={{ overflowX: "auto", padding: 60, margin: "auto" }}>
      <Timeline
        mode="left"
        style={{
          display: "flex",
          flexDirection: "row",
          minWidth: 1200,
        }}
      >
        {data.map((item) => (
          <div>
            <Timeline.Item
              key={item?.id}
              dot={
                <div
                  style={{
                    textAlign: "center",
                  }}
                >
                  {/* ICONO */}
                  <div style={{ fontSize: 30, color: "#003f70" }}>
                    <img src={item?.icon} height="40" width="40" alt="icon" />
                  </div>

                  {/* VALOR */}
                  <div
                    style={{
                      fontWeight: "bold",
                      fontSize: 16,
                      color: "#000",
                      marginTop: "10px",
                    }}
                  >
                    {item?.value}
                  </div>
                  <div
                    style={{
                      fontWeight: "bold",
                      fontSize: 12,
                      color: "#000",
                      marginTop: "10px",
                    }}
                  >
                    {item?.name}
                  </div>
                </div>
              }
            >
              {/* TEXTO ABAJO */}
            </Timeline.Item>
          </div>
        ))}
      </Timeline>
    </div>
  );
};

export default HorizontalTimeline;
